import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { TutoresEntidadBenficiariaDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';



import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class TutoresEntidadBenficiariaService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getTutoresEntidadBenficiariaService(): Observable<BodyListResponse<TutoresEntidadBenficiariaDTO>> {
    return this.http.get<BodyListResponse<TutoresEntidadBenficiariaDTO>>(API_URL + '/api/v1/tutoresEntidadBenficiaria/todos');
  }

  guardarTutoresEntidadBenficiariaService(tutoresEntidadBenficiariaDTO: TutoresEntidadBenficiariaDTO): Observable<BodyResponse<TutoresEntidadBenficiariaDTO>> {
    return this.http.post<BodyResponse<TutoresEntidadBenficiariaDTO>>(API_URL + '/api/v1/tutoresEntidadBenficiaria', tutoresEntidadBenficiariaDTO);
  }

  getTutoresEntidadBenficiariaPorCodigoService(codigo: string): Observable<BodyResponse<TutoresEntidadBenficiariaDTO>> {
    return this.http.get<BodyResponse<TutoresEntidadBenficiariaDTO>>(API_URL + '/api/v1/tutoresEntidadBenficiaria/' + codigo);
  }
}
